module.exports = __webpack_public_path__ + "img/1531370623.7f970202.jpg";